// extracted by mini-css-extract-plugin
export default {"cart-page-body":"CartPage_cart-page-body__7NaaL","title":"CartPage_title__m9btC"};